/* One original accessible navigation, portaled only while pinned. No cart/review mutations. */
(() => {
  const selector='.mg-e405-details,.mg-e425-details,.mg-e605-details';
  function initialize(root) {
    if(root.classList.contains('mg-pdp-nav-portal')||root.dataset.responsiveReady)return;
    const nav=root.querySelector('.section-nav');if(!nav)return;
    root.dataset.responsiveReady='true';
    const slot=document.createElement('div');slot.className='mg-pdp-nav-slot';
    nav.before(slot);slot.append(nav);
    const portal=document.createElement('div');
    portal.className=root.className+' mg-pdp-nav-portal';portal.hidden=true;
    document.body.append(portal);
    const header=document.querySelector('store-header');
    const links=[...nav.querySelectorAll('a[href^="#"]')];
    let frame=0,pinned=false,lastOffset=-1,lastHeight=0;
    const headerOffset=()=>{
      if(!header)return 0;
      const r=header.getBoundingClientRect();
      return r.top<innerHeight&&r.bottom>0?Math.max(0,Math.round(r.bottom)):0;
    };
    function update() {
      frame=0;if(!root.isConnected){cleanup();return;}
      const top=headerOffset(),height=Math.ceil(nav.getBoundingClientRect().height);
      if(top!==lastOffset){
        root.style.setProperty('--mg-pdp-header-offset',top+'px');
        portal.style.setProperty('--mg-pdp-header-offset',top+'px');lastOffset=top;
      }
      if(height&&height!==lastHeight){slot.style.minHeight=height+'px';lastHeight=height;}
      const shouldPin=slot.getBoundingClientRect().top<=top;
      if(shouldPin!==pinned){
        pinned=shouldPin;
        if(pinned){portal.hidden=false;portal.append(nav);}
        else{slot.append(nav);portal.hidden=true;}
      }
      let active=null,nearest=-Infinity;
      links.forEach(a=>{
        const target=document.getElementById(a.hash.slice(1));
        if(target){const y=target.getBoundingClientRect().top;if(y<=top+height+32&&y>nearest){active=a;nearest=y;}}
      });
      links.forEach(a=>{if(a===active)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current');});
    }
    function schedule(){if(!frame)frame=requestAnimationFrame(update);}
    function navigate(e){
      const a=e.target.closest('a[href^="#"]');if(!a||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;
      const target=document.getElementById(a.hash.slice(1));if(!target)return;
      e.preventDefault();e.stopImmediatePropagation();
      const top=target.getBoundingClientRect().top+scrollY-headerOffset()-nav.getBoundingClientRect().height-12;
      history.pushState(null,'',a.hash);
      window.scrollTo({top:Math.max(0,top),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      if(!target.hasAttribute('tabindex')){target.setAttribute('tabindex','-1');target.addEventListener('blur',()=>target.removeAttribute('tabindex'),{once:true});}
      target.focus({preventScroll:true});schedule();
    }
    nav.addEventListener('click',navigate,true);
    addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);
    const resize='ResizeObserver'in window?new ResizeObserver(schedule):null;
    resize?.observe(nav);if(header)resize?.observe(header);
    const mutation=header?new MutationObserver(schedule):null;
    mutation?.observe(header,{attributes:true,attributeFilter:['class','style']});
    header?.addEventListener('transitionend',schedule);
    function cleanup(){
      cancelAnimationFrame(frame);removeEventListener('scroll',schedule);removeEventListener('resize',schedule);
      resize?.disconnect();mutation?.disconnect();header?.removeEventListener('transitionend',schedule);
      nav.removeEventListener('click',navigate,true);portal.remove();
    }
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload',cleanup,{once:true});
    update();
  }
  const scan=()=>document.querySelectorAll(selector).forEach(initialize);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);
})();
